module.exports = __webpack_public_path__ + "img/sliderBtnLeft.b3f80063.svg";